module.exports = __webpack_public_path__ + "static/media/vertical-master-1.7a633d76.svg";